module.exports = __webpack_public_path__ + "static/img/2020-11-16 16.34.52.ca48a41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2020-11-16 16.34.52.jpg
// module id = HstQ
// module chunks = 4